module.exports = __webpack_public_path__ + "img/no-task@2x.59c5623f.png";